<template>
  <div class="skillVue">
    <div class="o-main-content-area c-responsive-fixwidth pad-adjust">
        <!-- Heading Section -->
        <div class="row">
            <div class="col-md-3" :class="skillComponent== 2?'p-0':'p-3'">
                <!-- <p class="u-back" v-if="skillComponent == 1 || skillComponent == 2"><a href="javascript: void(0)" @click="goToSkills()"><i class="fa fa-chevron-left"></i> Back</a></p> -->
                <div class="text-right" v-if="skillComponent == 2">
                    <ul class="o-filter-area">
                        <li class="o-search-field" v-if="skillComponent == 2">
                            <label for="rate_table" class="mt-5">Rate Table:</label>
                        </li>
                        <li class="o-search-field" v-if="skillComponent == 2">
                            <div class="input-group stylish-input-group mr-10">
                                <div class="common-label-input--modalwidth o-custom-dropdown">
                                    <select v-model="selectedRateId" @change="getSkills()" class="form-control" id="rate_table" name="rate_table" placeholder="Select Rate Table" data-vv-delay="500">
                                        <option value="">--- Select ---</option>
                                        <option v-for="(rate,index) in rates" :key="index" :value="rate.id">{{rate.name}}</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </div> 
                            </div>
                        </li>
                    </ul>
                </div>
                <h1 class="h1" v-if="skillComponent != 2">{{(this.skillComponent == 1)?"Archived Skills":(this.skillComponent == 2)?"Rate Tables":"Skills"}}</h1>
            </div>
            <div class="col-md-9" :class="skillComponent== 2?'text-left p-0':'text-right'">
                <ul class="o-filter-area">
                    <li class="o-search-field" v-if="skillComponent == 2">
                        <label for="rate_table" class="mt-5">Base Rate:</label>
                    </li>
                    <li class="o-search-field" v-if="skillComponent == 2">
                        <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Base Rate" v-model="base_rate">
                        </div>
                    </li>
                    <li class="o-search-field" v-if="skillComponent == 2">
                        <div class="input-group stylish-input-group mr-10">
                            <!-- <button class="btn btn-primary" type="button" @click="updateSkillBaseRate()">Update</button> -->
                            <a id="update_all" href="javascript: void(0)" @click="updateSkillsBaseRate()" class="c-solid-btn btn-save-skill" :class="{'greyBg': userRoleSlug=='auditor'}">Update All</a>
                        </div>
                    </li>
                    <li class="o-search-field">
                        <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Search" v-model="searchSkill" v-on:input="searchSkillMethod()">
                            <span class="input-group-addon">
                                <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>
                    </li>
                    <li v-if="skillComponent == 0 || skillComponent == 2">
                        <a href="javascript: void(0)" @click="goToArchiveSkills()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-archive" aria-hidden="true"></i> Archived Skills</a>
                    </li>
                    <li v-if="skillComponent == 1 || skillComponent == 2">
                        <a href="javascript: void(0)" @click="goToSkills()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-wrench" aria-hidden="true"></i> Skills</a>
                    </li>
                    <li v-if="getPower('addSkill')&&!skillComponent">
                        <a href="javascript: void(0)" class="c-common-btn c-common-btn--green" @click="addSkillModal()"><i class="fa fa-plus" aria-hidden="true"></i> Add New Skill</a>
                    </li>
                    <li v-if="getPower('ImportCSV')&&!skillComponent">
                        <a href="javascript: void(0)" @click="importCSV()" class="c-common-btn c-solid-btn--blue"><i class="fa fa-upload" aria-hidden="true"></i> Skills CSV Import</a>
                    </li>
                    <li v-if="skillComponent == 0 || skillComponent == 1">
                        <a href="javascript: void(0)" @click="goToRateTable()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-table" aria-hidden="true"></i>Rate Tables</a>
                    </li>                        

                </ul>
            </div>
        </div>
        <!-- /Heading Section -->
    </div>
    <SkillResults :myProp="search_query" :rates="rates" v-if="skillComponent == 0" />
    <ArchivedSkills :myProp="search_query" v-if="skillComponent == 1" />
    <RateTable :myProp="search_query" :rateId="selectedRateId" v-if="skillComponent==2 && selectedRateId" />
    <div v-else-if="skillComponent==2">Plese Wait and select a rate table on top</div>

   <modal name="add-skill"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
     <div class="modal-add-newJob" tabindex="-1" role="dialog">
        <div  role="document">
            <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center">
                    <button @click="closeAddSkill()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Add Skill</h4>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body">
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Skill Name:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                  <input type="text" class="form-control" placeholder="Text Input"  v-validate="{required: true}" name="name" v-model="addSkill.name">
                               <span v-show="errors.has('name') && this.validation_err == 1" class="err-msg">{{ errors.first('name') }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Sort Priority:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                          <input type="text" class="form-control" placeholder="Text Input" v-model="addSkill.priotiy">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Description:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                  <textarea placeholder="Text Area" v-model="addSkill.description" class="form-control" rows="6" v-validate="{required: true}" name="description"></textarea>
                                    <span v-show="errors.has('description') && this.validation_err == 1" class="err-msg">{{ errors.first('description') }}</span>
                                    </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeAddSkill()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <li>
                            <a href="javascript: void(0)" @click="addNewSkill()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
   </modal>
   <modal name="import-csv-modal" height="auto" :scrollable="true" class="modal-dialog modal-sm">
     <div class="modal-add-newJob" tabindex="-1" role="dialog">
        <div  role="document">
            <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center">
                    <button @click="closeimportCSV()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Import CSV</h4>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body" v-loading.this.lock="lockCSV">

                    <div class="row">
                        <div class="col-sm-12">
                            <h2 class="h2 text-center">Please Read Before Upload</h2>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                <p class="ps1">To prepare your CSV for the import, you must ensure the following:</p>
                                <ul class="skill-details">
                                    <li>1. The CSV must not contain blank rows which separate valid records.</li>
                                    <li>2. The first row must consist of the field names related to the data</li>
                                    <li>3. Acceptable format for upload: <strong>ods,xlsx,xls.csv</strong></li>
                                </ul>
                            </div>
                            <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                <div class="table-responsive o-no-margin-bottom">
                                  <table class="table table-bordered o-demo-table o-no-margin-bottom">
                                    <thead>
                                      <tr>
                                        <th>Name</th>
                                        <th>Priority</th>
                                        <th>Description</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Carpenter</td>
                                        <td>2</td>
                                        <td>Lorem Ipsum</td>
                                      </tr>
                                      <tr>
                                        <td>Electrician</td>
                                        <td>3</td>
                                        <td>Lorem Ipsum</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="o-emp-csv-download"><strong>- OR -</strong> Download sample <a href="static/assets/download/sample-skill.csv" download class="o-csv-download"><i class="fa fa-download" aria-hidden="true"></i></a></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <hr class="o-modal-separetor" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                <button class="btn c-common-btn c-common-btn--small c-common-btn--green o-csv-upload">Choose File</button>
                                <input class="" type="file" name="myfile" @change="uploadCSV($event)"/>
                                <!-- <span>file name</span> -->
                            </div>
                        </div>
                    </div>

                    <!--
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Sort Priority:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                          <input type="text" class="form-control" placeholder="Text Input" v-model="addSkill.priotiy">
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Description:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                  <textarea placeholder="Text Area" v-model="addSkill.description" class="form-control" rows="6" v-validate="{required: true}" name="description"></textarea>
                                    <span v-show="errors.has('description') && this.validation_err == 1" class="err-msg">{{ errors.first('description') }}</span>
                                    </label>
                            </div>
                        </div>
                    </div>
                    -->
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeimportCSV()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <!-- <li>
                            <a @click="" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                        </li> -->
                    </ul>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
   </modal>

  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import { bus } from '../../main';
    import SkillResults from './skillList';
    import ArchivedSkills from './archiveSkills';
    import RateTable from './rateTable';
    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
                userRoleSlug: 'userRoleSlug'
            })
        },
        components: {
            'SkillResults': SkillResults,
            'ArchivedSkills': ArchivedSkills,
            'RateTable': RateTable
        },
        data() {
            return {
                base_rate: '',
                selectedRateId: '1',
                rates: [],
                skills: [],
                total: 0,
                storeMore: [],
                page_no: 3,
                sortSkill: 'name',
                // addSkill:{'name':"",'priotiy':"",'description':"",'client_id':0},
                addSkill: {
                    'name': "",
                    'description': "",
                    'client_id': 0
                },
                next_page: "",
                search_query: "",
                validation_err: 0,
                status_message: "",
                skill_id: 0,
                skill_key: 0,
                presentSkill: [],
                presentEmployees: [],
                lockEmployees: false,
                assignable_employees: [],
                archivedSkill: [],
                skillComponent: 0, //0 for all and 1 for archived skills
                searchSkill: '',
                lockCSV: false
            }
        },
        mounted() {
            this.getRates();
            this.getSkills();
        },
        created() {
            bus.$on('changeBaseRate', (amount) => {
                this.base_rate = amount;
                this.searchSkill = '';
            });
        },
        beforeMount() {
            this.addSkill.client_id = this.userClientID;
        },
        watch: {
            // selectedRateId(newVal) {
            //     this.getAllSkillS();
            // }
        },
        methods: {
            getRates() {
                service.get('getRates', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.rates = res.data.result;
                    // console.log(this.rates);
                }).catch((err) => {
                    console.log(err);
                });
            },
            updateSkillsBaseRate() {
                if(this.userRoleSlug=='auditor') {
                    return;
                }
                let params = {
                    skill: 'all',
                    amount: this.base_rate,
                    rate_id: this.selectedRateId
                }
                service.post('skill/setBaseRate', params, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.status_message = res.data.status_message;
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Skill Updated Successfully.',
                        type: 'success'
                    });
                    let tempRateId = this.selectedRateId;
                    this.selectedRateId = 0;
                    setTimeout(() => {
                        this.selectedRateId = tempRateId;
                    }, 200);
                   
                }).catch((err) => {
                    console.log(err);
                })             
            },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            addNewSkill() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;

                        service.post('skill', this.addSkill, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.status_message = res.data.status_message;
                            setTimeout(() => {
                                this.$modal.hide('add-skill');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Skill Added Successfully.',
                                type: 'success'
                            });
                            this.search_query = {
                                'test': 1
                            };

                        }).catch((err) => {
                            console.log(err);
                        })

                    } else
                        this.validation_err = 1;

                });
            },
            addSkillModal() {
                this.addSkill['name'] = "";
                this.addSkill['description'] = "";
                //this.addSkill['priotiy']="";
                this.status_message = "";
                this.$modal.show('add-skill');
            },
            closeAddSkill() {
                this.$modal.hide('add-skill');
            },
            goToArchiveSkills() {
                this.searchSkill = '';
                this.skillComponent = 1;
            },
            goToRateTable() {
                this.searchSkill = '';
                this.skillComponent = 2;
            },
            goToSkills() {
               this.searchSkill = '';
                this.skillComponent = 0;
            },
            importCSV() {
                this.$modal.show('import-csv-modal');
            },
            closeimportCSV() {
                this.$modal.hide('import-csv-modal');
            },
            uploadCSV(e) {
                this.lockCSV = true;
                //  console.log('e.target.files', e.target.files[0]);
                var form = new FormData();
                form.append("skillFile", e.target.files[0]);
                // var params = {
                //
                //   'skillFile' : e.target.files[0]
                // };
                service.post('skill/skillCSV', form, {
                        'Authorization': this.userToken,
                        'Content-Type': 'multipart/form-data',
                        'clientId': this.userClientID,

                    })
                    .then((res) => {
                        // this.status_message = res.data.status_message;
                        // setTimeout(() => {
                        //     this.$modal.hide('add-skill');
                        // }, 500);
                        this.lockCSV = false;
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Skill Added Successfully.',
                            type: 'success'
                        });
                        this.search_query = {
                            'test': 1
                        };
                        this.closeimportCSV();


                    }).catch((err) => {
                        console.log(err);
                        this.lockCSV = false;
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Invalid file format. Please read the instruction before upload.',
                            type: 'error'
                        });
                    })

            },
            searchSkillMethod() {
                this.search_query = this.searchSkill;
            },
            async getSkills() {  
                console.log("Check ViewSkills");              
                await service.get('skill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.skills = res.data.result.data;
                    this.base_rate = this.skills[0].skill_rates[parseInt(this.selectedRateId)-1].amount;
                }).catch((err) => {
                   console.log(err)
                });
            },
        }
    }

</script>

<style scoped>
.greyBg {
    background-color: #c5c5c5!important;
    cursor: not-allowed;
    color: #e1e1e1;
}
#update_all:focus {
    color: #ffffff;
    background-color: #1AB677;
}
.p-0{
    padding:0!important;
}
.mr-10{
    margin-right:10px;
}
</style>
